module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-navbar', {
    staticClass: "formCard",
    staticStyle: {
      "border-radius": "5px !important",
      "padding-left": "0px"
    },
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "primary"
    }
  }, [_c('b-navbar-nav', [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "light"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_c('md-icon', {
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("skip_previous")]), _vm._v("Back\n          ")], 1)], 1), _vm._v(" "), _c('b-navbar-brand', {
    attrs: {
      "center": ""
    }
  }, [_vm._v("Daily TPT Expense Details")])], 1), _vm._v(" "), (_vm.visible) ? _c('div', [_c('b-card', [_c('b-collapse', {
    attrs: {
      "id": "collapse-2"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Type")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.CustomDateList,
      "option-value": "DVal",
      "option-text": "DText",
      "placeholder": "Select",
      "isDisabled": _vm.Filter.QFlag
    },
    on: {
      "input": function($event) {
        _vm.getCurrentLastDate()
      }
    },
    model: {
      value: (_vm.Filter.QDFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "QDFilter", $$v)
      },
      expression: "Filter.QDFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Date")]), _vm._v(" "), _c('date-range-picker', {
    attrs: {
      "always-show-calendars": _vm.showCal,
      "startDate": _vm.startDate,
      "endDate": _vm.endDate,
      "locale-data": _vm.locale,
      "disabled": _vm.Filter.DFlag ? true : false
    },
    on: {
      "update": _vm.getAssignmentData
    },
    model: {
      value: (_vm.Filter.dateRange),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "dateRange", $$v)
      },
      expression: "Filter.dateRange"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Branch")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllBranchList'],
      "id": "branchfilter",
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "All",
      "isDisabled": _vm.$sessionsStorage.get('designation') != 'Admin' ? true : false
    },
    on: {
      "input": _vm.getAssignmentData
    },
    model: {
      value: (_vm.Filter.branchfilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "branchfilter", $$v)
      },
      expression: "Filter.branchfilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Client")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllClientList'],
      "id": "clientfilter",
      "option-value": "clientId",
      "option-text": "clientName",
      "placeholder": "Select Client Name"
    },
    on: {
      "input": _vm.getAssignmentData
    },
    model: {
      value: (_vm.Filter.clientIdFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "clientIdFilter", $$v)
      },
      expression: "Filter.clientIdFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Pickup")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['commonDropdownMaster/getAllPickupList'],
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select Pickup Location"
    },
    on: {
      "input": _vm.getAssignmentData
    },
    model: {
      value: (_vm.Filter.PICKfilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "PICKfilter", $$v)
      },
      expression: "Filter.PICKfilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Stuffing")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['commonDropdownMaster/getAllStuffingList'],
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select Stuffing Location"
    },
    on: {
      "input": _vm.getAssignmentData
    },
    model: {
      value: (_vm.Filter.STUFFfilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "STUFFfilter", $$v)
      },
      expression: "Filter.STUFFfilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Handover")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['commonDropdownMaster/getAllHandoverList'],
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select Handover Location"
    },
    on: {
      "input": _vm.getAssignmentData
    },
    model: {
      value: (_vm.Filter.HANDfilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "HANDfilter", $$v)
      },
      expression: "Filter.HANDfilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("BOE Filter")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "text",
      "formatter": _vm.capitalizeAll,
      "placeholder": "Search BOE Filter",
      "id": "BOEfilter",
      "name": "BOEfilter",
      "autocomplete": "off"
    },
    on: {
      "input": _vm.getAssignmentData
    },
    model: {
      value: (_vm.Filter.BOEfilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "BOEfilter", $$v)
      },
      expression: "Filter.BOEfilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Shipper INV Filter")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "text",
      "formatter": _vm.capitalizeAll,
      "placeholder": "Search Shipper INV Filter",
      "id": "SHIPBillNofilter",
      "name": "SHIPBillNofilter",
      "autocomplete": "off"
    },
    on: {
      "input": _vm.getAssignmentData
    },
    model: {
      value: (_vm.Filter.SHIPBillNofilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "SHIPBillNofilter", $$v)
      },
      expression: "Filter.SHIPBillNofilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Booking NO Filter")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "text",
      "formatter": _vm.capitalizeAll,
      "placeholder": "Search Booking NO Filter",
      "id": "BookingNofilter",
      "name": "BookingNofilter",
      "autocomplete": "off"
    },
    on: {
      "input": _vm.getAssignmentData
    },
    model: {
      value: (_vm.Filter.BookingNofilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "BookingNofilter", $$v)
      },
      expression: "Filter.BookingNofilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Common Filter")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "text",
      "formatter": _vm.capitalizeAll,
      "placeholder": "Search Common Filter",
      "id": "CommonFilter",
      "name": "CommonFilter",
      "autocomplete": "off"
    },
    on: {
      "input": _vm.getAssignmentData
    },
    model: {
      value: (_vm.Filter.CommonFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "CommonFilter", $$v)
      },
      expression: "Filter.CommonFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "md": "3"
    }
  }, [_c('b-button', {
    staticClass: "ml-1 pull-right",
    staticStyle: {
      "font-size": "0.675rem margin-left: auto"
    },
    attrs: {
      "size": "sm",
      "variant": "danger"
    },
    on: {
      "click": _vm.clearFilter
    }
  }, [_vm._v("Reset")])], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('b-card', [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-navbar', {
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "info"
    }
  }, [_c('b-navbar-nav', {
    staticClass: "ml-auto"
  }, [_c('b-nav-form', [(_vm.DateLabel.StartDate) ? _c('h6', {
    staticClass: "error"
  }, [_vm._v("\n                    Start Date : " + _vm._s(_vm.DateLabel.StartDate) + " / End Date :\n                    " + _vm._s(_vm.DateLabel.EndDate) + "\n                  ")]) : _vm._e(), _vm._v(" "), _c('b-button-group', {
    staticClass: "m2-1 text-right",
    attrs: {
      "size": "sm"
    }
  }, [_c('b-button', {
    class: 'ml-4' + _vm.visible ? null : 'collapsed',
    staticStyle: {
      "font-size": "0.675rem"
    },
    attrs: {
      "variant": _vm.Filter.CommonFilter ||
        _vm.Filter.clientIdFilter ||
        _vm.Filter.branchfilter ||
        _vm.Filter.PICKfilter ||
        _vm.Filter.HANDfilter ||
        _vm.Filter.STUFFfilter ||
        _vm.Filter.BOEfilter ||
        _vm.Filter.SHIPBillNofilter ||
        _vm.Filter.BookingNofilter ||
        _vm.Filter.QDFilter ||
        _vm.Filter.QFlag ||
        _vm.Filter.DFlag ||
        _vm.Filter.dateRange.startDate ||
        _vm.Filter.dateRange.endDate ?
        'danger' :
        'primary',
      "aria-expanded": _vm.visible ? 'true' : 'false',
      "aria-controls": "collapse-4"
    },
    on: {
      "click": function($event) {
        _vm.visible = !_vm.visible
      }
    }
  }, [_vm._v(_vm._s(_vm.Filter.CommonFilter ||
    _vm.Filter.clientIdFilter ||
    _vm.Filter.branchfilter ||
    _vm.Filter.PICKfilter ||
    _vm.Filter.HANDfilter ||
    _vm.Filter.STUFFfilter ||
    _vm.Filter.BOEfilter ||
    _vm.Filter.SHIPBillNofilter ||
    _vm.Filter.BookingNofilter ||
    _vm.Filter.QDFilter ||
    _vm.Filter.QFlag ||
    _vm.Filter.DFlag ||
    _vm.Filter.dateRange.startDate ||
    _vm.Filter.dateRange.endDate ?
    "Filter ON" :
    "Filter OFF"))]), _vm._v(" "), _c('b-button', {
    staticClass: "mr-2",
    attrs: {
      "variant": "secondary"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("Back")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.getTPTExpenseList.length > 0) ? _c('b-col', {
    staticClass: "mt-1",
    attrs: {
      "md": "12"
    }
  }, [_c('div', [_c('b-pagination', {
    attrs: {
      "limit": "8",
      "align": "center",
      "per-page": _vm.pagination.perPage,
      "total-rows": _vm.getTPTExpenseList.length
    },
    on: {
      "change": function($event) {
        _vm.onPageChange($event)
      }
    },
    model: {
      value: (_vm.pagination.currentPage),
      callback: function($$v) {
        _vm.$set(_vm.pagination, "currentPage", $$v)
      },
      expression: "pagination.currentPage"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "gutr"
  }, [_c('h5', {
    staticClass: "text-muted pull-right mt-2"
  }, [(_vm.isLoading == false) ? _c('small', [_vm._v(_vm._s(_vm.getTPTExpenseList.length) + " Entries")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive tableMain gutr"
  }, [_c('b-table', {
    staticClass: "position-relative",
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "items": _vm.getTPTExpenseList,
      "responsive": "",
      "fields": _vm.TPTExpfields,
      "primary-key": "allModuleId",
      "per-page": _vm.pagination.perPage,
      "current-page": _vm.pagination.currentPage,
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "sort-direction": _vm.sortDirection
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "allModuleId",
      fn: function(row0) {
        return [_c('span', [_vm._v(_vm._s(row0.index + 1 + (_vm.pagination.currentPage - 1) * _vm.pagination.perPage))])]
      }
    }, {
      key: "JOBNO",
      fn: function(row1) {
        return [_c('span', [_vm._v("JOB NO : " + _vm._s(row1.item.JOBNO)), _c('br')]), _vm._v(" "), _c('span', [_vm._v("JOB Date : " + _vm._s(row1.item.JOBDate)), _c('br')]), _vm._v(" "), _c('span', [_vm._v("RaisedBy : " + _vm._s(row1.item.RaisedBy)), _c('br')]), _vm._v(" "), _c('span', [_vm._v("Rasied From : " + _vm._s(row1.item.RasiedFrom)), _c('br')])]
      }
    }, {
      key: "clientName",
      fn: function(row2) {
        return [_c('span', [_vm._v("Client : " + _vm._s(row2.item.clientName)), _c('br')]), _vm._v(" "), _c('span', [_vm._v("Sline : " + _vm._s(row2.item.Sline)), _c('br')])]
      }
    }, {
      key: "BOE",
      fn: function(row3) {
        return [_c('span', [_vm._v(_vm._s(row3.item.BOE))])]
      }
    }, {
      key: "PICK",
      fn: function(row4) {
        return [_c('span', [_vm._v("PICK : " + _vm._s(row4.item.PICK)), _c('br')]), _vm._v(" "), _c('span', [_vm._v("HAND : " + _vm._s(row4.item.HAND)), _c('br')]), _vm._v(" "), _c('span', [_vm._v("STUFF : " + _vm._s(row4.item.STUFF)), _c('br')])]
      }
    }, {
      key: "HAND",
      fn: function(row6) {
        return [_c('b-button', {
          staticClass: "mt-1",
          staticStyle: {
            "font-size": "0.675rem"
          },
          attrs: {
            "variant": row6.item.AddTypevalue == '1' ? 'info' : 'danger',
            "size": "xs"
          },
          on: {
            "click": function($event) {
              _vm.AddMain(row6.item)
            }
          }
        }, [_vm._v(_vm._s(row6.item.AddTypeLabel))])]
      }
    }])
  })], 1)]) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.AssTPTExpArr.length > 0) ? _c('b-card', {
    staticClass: "formCard"
  }, [_vm._l((_vm.AssTPTExpArr), function(ass_itm, ass_idx) {
    return _c('b-card-text', {
      key: ass_idx
    }, [_c('div', [_c('b-row', [_c('b-col', {
      attrs: {
        "lg": "4"
      }
    }, [_c('b', {
      staticStyle: {
        "color": "blue",
        "font-weight": "bold",
        "font-size": "18px"
      }
    }, [_vm._v("JOB No : " + _vm._s(ass_itm.JOBNO))]), _vm._v(" "), (ass_itm.JOBNO_err) ? _c('span', {
      staticClass: "error"
    }, [_vm._v(_vm._s(ass_itm.JOBNO_err))]) : _vm._e()]), _vm._v(" "), _c('b-col', {
      attrs: {
        "lg": "8"
      }
    }, [(
      _vm.last_updated != '' &&
      _vm.last_updated != null &&
      _vm.last_updated != undefined
    ) ? _c('span', {
      staticClass: "pull-right"
    }, [_c('b', {
      staticClass: "error"
    }, [_vm._v(_vm._s(_vm.last_updated))])]) : _vm._e(), _vm._v(" "), _c('b-button', {
      staticClass: "ml-auto pull-right",
      staticStyle: {
        "font-size": "0.675rem"
      },
      attrs: {
        "id": "show-btn",
        "size": "sm",
        "variant": "danger"
      },
      on: {
        "click": function($event) {
          _vm.removeMain(ass_idx)
        }
      }
    }, [_vm._v("\n                  Remove\n                  "), _c('i', {
      staticClass: "fa fa-minus",
      attrs: {
        "aria-hidden": "true"
      }
    })])], 1)], 1), _vm._v(" "), _c('b-card', {
      staticClass: "mt-2"
    }, [_c('div', {
      staticClass: "table-responsive tableMain"
    }, [_c('table', {
      staticClass: "table table-sm table-bordered"
    }, [_c('tbody', {
      staticStyle: {
        "background": "white"
      }
    }, [_c('tr', [_c('th', {
      attrs: {
        "scope": "col"
      }
    }, [_vm._v("SN.")]), _vm._v(" "), _c('th', {
      attrs: {
        "scope": "col"
      }
    }, [_vm._v("\n                        Amount "), _c('span', {
      staticClass: "error"
    }, [_vm._v("* (Required)")])]), _vm._v(" "), _c('th', {
      attrs: {
        "scope": "col"
      }
    }, [_vm._v("\n                        Currency"), _c('span', {
      staticClass: "error"
    }, [_vm._v("* (Required)")])]), _vm._v(" "), _c('th', {
      attrs: {
        "scope": "col"
      }
    }, [_vm._v("\n                        Description"), _c('span', {
      staticClass: "error"
    }, [_vm._v("* (Required)")])]), _vm._v(" "), _c('th', {
      attrs: {
        "scope": "col"
      }
    }, [_vm._v("Remarks")]), _vm._v(" "), _c('th', {
      attrs: {
        "scope": "col"
      }
    }, [_vm._v("Doc.")]), _vm._v(" "), _c('th', {
      attrs: {
        "scope": "col"
      }
    }, [_vm._v("\n                        Action\n                        "), _c('b-button', {
      staticStyle: {
        "font-size": "0.675rem"
      },
      attrs: {
        "id": "show-btn",
        "size": "sm",
        "variant": "primary"
      },
      on: {
        "click": function($event) {
          _vm.addTPTExp(ass_idx, ass_itm)
        }
      }
    }, [_vm._v("\n                          Add "), _c('i', {
      staticClass: "fa fa-plus",
      attrs: {
        "aria-hidden": "true"
      }
    })])], 1)]), _vm._v(" "), _vm._l((ass_itm.TPTExpArr), function(itm, idx) {
      return _c('tr', {
        key: idx
      }, [_c('th', {
        attrs: {
          "scope": "row"
        }
      }, [_vm._v(_vm._s(idx + 1))]), _vm._v(" "), _c('td', [_c('b-form-input', {
        attrs: {
          "disabled": itm.exp_id != '' ? true : false,
          "formatter": _vm.capitalizeAll,
          "id": "amount",
          "name": "amount",
          "type": "number"
        },
        on: {
          "input": function($event) {
            _vm.CheckValueNumbers($event)
          },
          "change": function($event) {
            _vm.CheckValueNumbers($event)
          },
          "keyup": function($event) {
            _vm.TotalAMT(ass_itm, ass_idx, idx, itm)
          }
        },
        model: {
          value: (itm.exp_amt),
          callback: function($$v) {
            _vm.$set(itm, "exp_amt", $$v)
          },
          expression: "itm.exp_amt"
        }
      }), _vm._v(" "), (itm.exp_amt_err) ? _c('span', {
        staticClass: "error"
      }, [_vm._v(_vm._s(itm.exp_amt_err))]) : _vm._e()], 1), _vm._v(" "), _c('td', [_c('model-list-select', {
        attrs: {
          "isDisabled": true,
          "list": _vm.$store.getters['common/getAllCurrencyList'],
          "option-value": "currency_id",
          "option-text": "currencyCode",
          "placeholder": "Select Currency"
        },
        model: {
          value: (itm.exp_currency_id),
          callback: function($$v) {
            _vm.$set(itm, "exp_currency_id", $$v)
          },
          expression: "itm.exp_currency_id"
        }
      }), _vm._v(" "), (itm.exp_currency_id_err) ? _c('span', {
        staticClass: "error"
      }, [_vm._v(_vm._s(itm.exp_currency_id_err))]) : _vm._e()], 1), _vm._v(" "), _c('td', [_c('b-form-textarea', {
        attrs: {
          "disabled": itm.exp_id != '' ? true : false,
          "formatter": _vm.capitalizeAll,
          "id": "description",
          "name": "description"
        },
        model: {
          value: (itm.exp_desc),
          callback: function($$v) {
            _vm.$set(itm, "exp_desc", $$v)
          },
          expression: "itm.exp_desc"
        }
      }), _vm._v(" "), (itm.exp_desc_err) ? _c('span', {
        staticClass: "error"
      }, [_vm._v(_vm._s(itm.exp_desc_err))]) : _vm._e()], 1), _vm._v(" "), _c('td', [_c('b-form-textarea', {
        attrs: {
          "disabled": itm.exp_id != '' ? true : false,
          "formatter": _vm.capitalizeAll,
          "id": "remark",
          "name": "remark"
        },
        model: {
          value: (itm.exp_remark),
          callback: function($$v) {
            _vm.$set(itm, "exp_remark", $$v)
          },
          expression: "itm.exp_remark"
        }
      }), _vm._v(" "), (itm.exp_remark_err) ? _c('span', {
        staticClass: "error"
      }, [_vm._v(_vm._s(itm.exp_remark_err))]) : _vm._e()], 1), _vm._v(" "), _c('td', [_c('Single-Upload', {
        attrs: {
          "index": ass_idx,
          "second_index": idx,
          "multiple": false,
          "documentName": 'TPTExpense_Multiple_Doc_',
          "otherDocName": 'TPTExpense_Multiple_Doc_',
          "folderName": 'Expense',
          "accept": '*',
          "state": Boolean(itm.exp_doc),
          "assign_no": ass_itm.JOBNO,
          "fileAllModuleId": ass_itm.allModuleId
        },
        model: {
          value: (itm.exp_doc),
          callback: function($$v) {
            _vm.$set(itm, "exp_doc", $$v)
          },
          expression: "itm.exp_doc"
        }
      }), _vm._v(" "), (itm.exp_doc_err) ? _c('span', {
        staticClass: "error"
      }, [_vm._v(_vm._s(itm.exp_doc_err))]) : _vm._e(), _c('br'), _vm._v(" "), (ass_itm.doc_path && itm.exp_doc) ? _c('a', {
        attrs: {
          "href": _vm.docURL + "/ASSIGNMENT_UPLOADS/" +
            ass_itm.doc_path +
            '/' +
            itm.exp_doc,
          "target": "_blank",
          "download": ""
        }
      }, [_vm._v("--View")]) : _vm._e()], 1), _vm._v(" "), _c('td', [_c('b-button', {
        staticClass: "ml-auto",
        staticStyle: {
          "font-size": "0.675rem"
        },
        attrs: {
          "disabled": itm.exp_id != '' ? true : false,
          "id": "show-btn",
          "size": "sm",
          "variant": "danger"
        },
        on: {
          "click": function($event) {
            _vm.removeTPTExp(idx, ass_idx, ass_itm, itm)
          }
        }
      }, [_vm._v("\n                          Remove\n                          "), _c('i', {
        staticClass: "fa fa-minus",
        attrs: {
          "aria-hidden": "true"
        }
      })])], 1)])
    }), _vm._v(" "), _c('tr', [_c('td', {
      attrs: {
        "colspan": "1"
      }
    }, [_c('b', {
      staticStyle: {
        "color": "blue",
        "font-weight": "bold",
        "font-size": "18px"
      }
    }, [_vm._v("Net Total")])]), _vm._v(" "), _c('td', {
      attrs: {
        "colspan": "5"
      }
    }, [_c('b', {
      staticStyle: {
        "color": "blue",
        "font-weight": "bold",
        "font-size": "18px"
      }
    }, [_vm._v(_vm._s(ass_itm.exp_netTot + " INR"))]), _vm._v(" "), (ass_itm.exp_netTot_err) ? _c('span', {
      staticClass: "error"
    }, [_vm._v(_vm._s(ass_itm.exp_netTot_err))]) : _vm._e()])])], 2)])])])], 1)])
  }), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "lg": "5"
    }
  }, [_c('b', {
    staticStyle: {
      "color": "red",
      "font-weight": "bold",
      "font-size": "18px"
    }
  }, [_vm._v("Final Total = " + _vm._s(_vm.TotAMT + " INR"))])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "lg": "2"
    }
  }, [(_vm.AssTPTExpArr.length > 0) ? _c('b-button', {
    staticClass: "mt-3",
    staticStyle: {
      "font-size": "0.675rem"
    },
    attrs: {
      "size": "sm",
      "variant": "primary",
      "id": "addButtonLoaderSB"
    },
    on: {
      "click": _vm.addAddTPTExpDetail
    }
  }, [_vm._v("Save & Submit\n            ")]) : _vm._e(), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loaderSB"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "lg": "5"
    }
  })], 1)], 2) : _vm._e(), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPop",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-484be0d8","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/expense/dailyTPTExpense.vue
// module id = 2588
// module chunks = 0